const styles = `:host {
  display: inline-flex;
  flex-direction: column;
  outline: none;
}
:host .control {
  border-width: 1px;
  border-style: solid;
  border-color: var(--goto-border-color-default);
  color: var(--goto-type-color-default);
  font: var(--goto-body-medium);
  height: 2.25rem;
  border-radius: var(--goto-radius-small);
  padding: 0 0.75rem;
  box-sizing: border-box;
  background-color: var(--goto-ui-01);
  outline: 0;
  min-height: 58px;
  height: inherit;
  resize: none;
  padding-top: 6px;
}
:host .control:hover {
  border-color: var(--goto-border-color-default);
}
:host .control::placeholder {
  color: var(--goto-text-02);
  font: var(--goto-body-medium);
  margin-top: var(--goto-spacing-01);
  display: inline-flex;
  opacity: 1;
  line-height: 1.3rem;
}
:host .info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--goto-spacing-02);
}
:host .counter {
  color: var(--goto-text-02);
  margin-top: var(--goto-spacing-01);
  font: var(--goto-caption-medium);
}
:host ::slotted([slot=helpertext]) {
  color: var(--goto-text-02);
  margin-top: var(--goto-spacing-01);
  font: var(--goto-caption-medium);
}

:host([resize=both]) .control {
  resize: both;
}

:host([resize=horizontal]) .control {
  resize: horizontal;
}

:host([resize=vertical]) .control {
  resize: vertical;
}

:host(:focus-within) .control {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-interactive-color-secondary-hover);
}

:host([success]) .control {
  border-color: var(--goto-input-success-border);
}
:host([success]) ::slotted([slot=helpertext]) {
  color: var(--goto-success-01);
}

:host([success]:focus-within) .control {
  border-color: var(--goto-input-success-border);
  box-shadow: var(--goto-highlight-success-small);
}

:host([readonly]) .control {
  border-color: var(--goto-border);
  background-color: var(--goto-surface-color-secondary);
  box-shadow: none;
  color: var(--goto-text-01);
}
:host([readonly]) .control input::placeholder {
  color: var(--goto-text-01);
}

:host([readonly]:focus-within) .control {
  border-color: var(--goto-border);
  background-color: var(--goto-surface-color-secondary);
  box-shadow: none;
  color: var(--goto-text-01);
}

:host([error]) .control {
  border-color: var(--goto-input-danger-border);
}
:host([error]) ::slotted([slot=helpertext]) {
  color: var(--goto-danger-01);
}

:host([error]:focus-within) .control {
  border-color: var(--goto-input-danger-border);
  box-shadow: var(--goto-highlight-error-small);
}

:host([fieldsize=small]) .control {
  font: var(--goto-body-small);
  height: 1.875rem;
}
:host([fieldsize=small]) .control::placeholder {
  font: var(--goto-body-small);
}

:host([fieldsize=large]) .control {
  height: 2.625rem;
}

:host([fieldsize=xlarge]) .control {
  height: 3rem;
}

.label {
  color: var(--goto-text-01);
  font: var(--goto-caption-medium-strong);
  display: block;
  margin-bottom: 2px;
}

:host([disabled]) .label {
  color: var(--goto-text-03);
}
:host([disabled]) .control {
  border-color: var(--goto-border);
  background-color: var(--goto-field-04);
  box-shadow: none;
  cursor: default;
  color: var(--goto-text-03);
}
:host([disabled]) .control::placeholder {
  color: var(--goto-text-03);
}
:host([disabled]) ::slotted([slot=helpertext]) {
  color: var(--goto-text-03);
}

:host([readonly]) .control {
  border-color: var(--goto-border);
  background-color: var(--goto-surface-color-secondary);
  box-shadow: none;
  color: var(--goto-text-01);
}
:host([readonly]) .control::placeholder {
  color: var(--goto-text-01);
}

:host([readonly]:focus-within) .control {
  border-color: var(--goto-border);
  background-color: var(--goto-surface-color-secondary);
  box-shadow: none;
  color: var(--goto-text-01);
}

:host([fullwidth]) {
  width: 100%;
}
:host([fullwidth]) .control {
  width: 100%;
}`; export default styles;